// eslint-disable-next-line @typescript-eslint/no-explicit-any
(window as any).global = window; // Required to mitigate Amplify Uncaught ReferenceError Global is not defined
(window as any).process = { env: { NODE_DEBUG: undefined } };
